var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (fieldsetCounter, globals, id) {
      






































































































pug_mixins["checkbox"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key
}
if (!attributes.attributes) {
attributes.attributes = {}
}
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": "checkbox schema-form-checkbox"},attributes.groupAttributes]), true)) + "\u003E\u003Cinput" + (pug.attrs(pug.merge([{"class": pug.classes([attributes.fieldHtmlClass], [true]),"type": "checkbox","ng-model": pug.escape(attributes.key),"ng-disabled": pug.escape(attributes.readonly),"id": pug.escape(id),"name": pug.escape(id),"required": pug.escape(attributes.required),"ng-true-value": pug.escape(attributes['ng-true-value']),"ng-false-value": pug.escape(attributes['ng-false-value']),"data-cy": pug.escape(attributes['data-cy'])},attributes.attributes]), true)) + "\u003E\u003Clabel" + (pug.attr("class", pug.classes([attributes.labelHtmlClass], [true]), false, true)+pug.attr("for", id, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E";
};




















































pug_mixins["radio"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.title && attributes.name) {
attributes.title = attributes.name
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key + '-' + attributes.index
}
pug_html = pug_html + "\u003Cinput" + (pug.attr("class", pug.classes([attributes.fieldHtmlClass], [true]), false, true)+pug.attr("id", id, true, true)+" type=\"radio\""+pug.attr("required", attributes.required, true, true)+pug.attr("name", attributes.key, true, true)+pug.attr("ng-model", attributes.key, true, true)+pug.attr("ng-disabled", attributes.readonly, true, true)+pug.attr("value", attributes.value, true, true)+pug.attr("ng-value", attributes['ng-value'], true, true)+pug.attr("data-cy", attributes['data-cy'], true, true)+pug.attr("ng-change", attributes['ng-change'], true, true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (" class=\"radio-inline\""+pug.attr("for", attributes.key + '-' + attributes.index, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
};






































































pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (!fieldsetCounter) {
fieldsetCounter = 0
}





















pug_html = pug_html + "\u003Cdiv class=\"cockpit_arbeitnmv-wrapper\"\u003E\u003Cdiv class=\"cockpit-panel__title\"\u003E{{ $ctrl.display_data.heading }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel__body\" overlay=\"!!$ctrl.loading.main\"\u003E\u003Cdiv ng-if=\"!$ctrl.is_decision_confirmed\"\u003E\u003Cdiv ng-switch=\"$ctrl.selected_option\"\u003E\u003Cdiv ng-switch-when=\"0\"\u003E\u003Cbr\u003E\u003Cdiv id=\"table-wrapper\"\u003E\u003Ctable id=\"desc\"\u003E\u003Ctr\u003E\u003Cth class=\"center\"\u003EWiderrufsbelehrung\u003C\u002Fth\u003E\u003C\u002Ftr\u003E\u003Ctr\u003E\u003Ctd\u003E\u003Cb\u003EWiderrufsrecht\u003C\u002Fb\u003E\u003Cbr\u003ESie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen.\u003Cbr\u003E\u003Cbr\u003EDie Widerrufsfrist beträgt vierzehn Tage ab dem Tag, an dem Sie oder ein von Ihnen benannter Dritter, der nicht der Beförderer ist,\ndie Waren in Besitz genommen haben bzw. hat.\u003Cbr\u003E\u003Cbr\u003EUm Ihr Widerrufsrecht auszuüben, müssen Sie dem Verkäufer (ValueNet Holding GmbH & Co. KG, Werinherstr. 91, 81543 München, mpp@valuenet.de) mittels einer eindeutigen Erklärung\n(z. B. ein mit der Post versandter Brief, Telefax oder E-Mail) über Ihren Entschluss, diesen Vertrag zu widerrufen, informieren.\u003Cbr\u003ESie können das Muster-Widerrufsformular oder eine andere eindeutige Erklärung auch auf unserer\u003Ca href=\"https:\u002F\u002Fportal.valuenet.de\u002Fassets\u002Ffiles\u002FMuster-Widerrufsformular.pdf\"\u003EWebseite\u003C\u002Fa\u003Eelektronisch ausfüllen und übermitteln. Machen Sie von dieser Möglichkeit Gebrauch, so werden wir Ihnen unverzüglich (z.B. per E-Mail) eine Bestätigung über den Eingang eines solchen Widerrufs übermitteln.\u003Cbr\u003E\u003Cbr\u003EZur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung über die Ausübung des Widerrufsrechts vor Ablauf der Widerrufsfrist absenden.\u003Cbr\u003E\u003Cbr\u003E\u003Cb\u003EFolgen des Widerrufs\u003C\u002Fb\u003E\u003Cbr\u003EWenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen erhalten haben, einschließlich der Lieferkosten (mit Ausnahme der zusätzlichen Kosten,\ndie sich daraus ergeben, dass Sie eine andere Art der Lieferung als die von uns angebotene, günstigste Standardlieferung gewählt haben), unverzüglich und spätestens binnen\nvierzehn Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über Ihren Widerruf dieses Vertrags bei uns eingegangen ist. Für diese Rückzahlung verwenden wir dasselbe Zahlungsmittel,\ndas Sie bei der ursprünglichen Transaktion eingesetzt haben, es sei denn, mit Ihnen wurde ausdrücklich etwas anderes vereinbart; in keinem Fall werden Ihnen wegen dieser Rückzahlung\nEntgelte berechnet.\u003Cbr\u003ESie haben die Waren unverzüglich und in jedem Fall spätestens binnen vierzehn Tagen ab dem Tag, an dem Sie uns über den Widerruf dieses Vertrags unterrichten, an ValueNet Holding\nGmbH & Co. KG, Werinherstr. 91, 81543 München zurückzusenden oder zu übergeben. Die Frist ist gewahrt, wenn Sie die Waren vor Ablauf der Frist von vierzehn Tagen absenden.\u003Cbr\u003E\u003Cbr\u003ESie tragen die unmittelbaren Kosten der Rücksendung der Waren.\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003C\u002Ftable\u003E\u003Cbr\u003E\u003C\u002Fdiv\u003E\u003Cp\u003E\u003C\u002Fp\u003EKaufprozess\u003Cp\u003E\u003C\u002Fp\u003EEs freut uns, dass Sie die Endgeräte käuflich erwerben möchten. Zusammengefasst bedeutet dies für Sie:\u003Cp\u003E\u003C\u002Fp\u003E\u003Cspan class=\"strong\"\u003EKäuferdaten\u003C\u002Fspan\u003E\u003Cbr\u003E{{$ctrl.employee.firstname}} {{$ctrl.employee.lastname}}\u003Cbr\u003E{{$ctrl.employee.address.street}}\u003Cbr\u003E{{$ctrl.employee.address.zip}} {{$ctrl.employee.address.city}}\u003Cp\u003E\u003C\u002Fp\u003E\u003Cspan class=\"strong\"\u003EVerkäuferdaten\u003C\u002Fspan\u003E\u003Cbr\u003EValueNet Holding GmbH & Co. KG\u003Cbr\u003EWerinherstr. 91\u003Cbr\u003E81541 München\u003Cp\u003E\u003C\u002Fp\u003ESie erwerben nachfolgend aufgeführte Objekte:\u003Cdiv id=\"table-wrapper\"\u003E\u003Ctable id=\"desc\"\u003E\u003Ctr\u003E\u003Cth\u003EGerätebezeichnung und Zustand\u003C\u002Fth\u003E\u003Cth\u003EStück\u003C\u002Fth\u003E\u003Cth\u003ENeuwert\u003C\u002Fth\u003E\u003Cth\u003EAblösepreis\u003C\u002Fth\u003E\u003C\u002Ftr\u003E\u003Ctr ng-repeat=\"article in $ctrl.basket['articles']\"\u003E\u003Ctd\u003E{{article['Artikelname']}}, gebraucht\u003C\u002Ftd\u003E\u003Ctd\u003E{{article['quantity']}}\u003C\u002Ftd\u003E\u003Ctd\u003E{{article['price'] | currency}}\u003C\u002Ftd\u003E\u003Ctd\u003E{{article['price'] * $ctrl.endprice_percentage | currency}}\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003C\u002Ftable\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003Cspan class=\"strong\"\u003EGesamtbetrag\u003C\u002Fspan\u003E\u003Cbr\u003E{{$ctrl.buying_price_brutto | currency }} Brutto - darin enthalten sind  {{$ctrl.buying_price * 0.19 | currency }} Mehrwertsteuer\u003Cp\u003E\u003C\u002Fp\u003EDie Geräte befinden sich bereits bei Ihnen, daher entfällt eine Belieferung. Dementsprechend entfallen die Versandkosten.\u003Cbr\u003EEs sind keine Neugeräte. Beschaffenheit und Zustand sind Ihnen bekannt.\u003Cbr\u003E\u003Cbr\u003E\u003Cspan class=\"strong\"\u003EGewährleistungsausschluss\u003C\u002Fspan\u003E\u003Cbr\u003EDie gesetzliche Gewährleistung entfällt, da Ihnen auf Grund der vorherigen Nutzung Zustand und existente Mängel bekannt sein müssen.\u003Cp\u003E\u003C\u002Fp\u003EBei Abschluss des Vorgangs erhalten Sie die Rechnung angezeigt und zum Download bereitgestellt. Die Rechnung wird in \"Meine Akte\" abgelegt und ist für Sie jederzeit abrufbar.\u003Cbr\u003EDas Zahlungsziel beträgt vierzehn Tage ab Rechnungsdatum.\u003Cbr\u003E\u003Cp\u003E\u003C\u002Fp\u003EMit Abschluss dieses Kaufvertrags stimmen Sie zu, dass wir bei Zahlungsverzug größer 30 Tage Ihren Arbeitgeber über Ihren Zahlungsrückstand in Kenntnis setzen werden,\nbitte sorgen Sie daher zur Vermeidung etwaiger Unannehmlichkeiten für eine fristgerechte Begleichung.\u003C\u002Fdiv\u003E\u003Cdiv ng-switch-when=\"1\"\u003E\u003Cp\u003EWenn Sie sich für die Rückgabe der Geräte entscheiden, beachten Sie bitte folgende Informationen:\u003Col\u003E\u003C\u002Fol\u003E\u003Cli\u003EVor der Rückgabe sind die Geräte zu reinigen.\u003C\u002Fli\u003E\u003Cli\u003EDie Geräte haben bei der Rückgabe in einem der vertragsgemäßen Abnutzung entsprechenden Zustand zu sein, d.h. die Geräte müssen funktionsfähig und optisch\u003C\u002Fli\u003Eeinwandfrei sein.\u003Cli\u003EDie Festplatte muss gereinigt, eventuelle Passwörter müssen deaktiviert sein, Geräte müssen ggf. auf Werkseinstellung zurückgesetzt sein.\u003C\u002Fli\u003E\u003Cli\u003EDie Geräte müssen ggf. in persönlichen Profilen (zB. Apple iCloud) deaktiviert werden.\u003C\u002Fli\u003E\u003Cli\u003EDie Geräte müssen vollständig, inkl. aller zur Installation notwendigen Datenträger (Booting und Recovery-CD, DVD oder Disketten) sowie gelieferter Zubehörteile wie Ladekabel zurückgegeben werden.\u003C\u002Fli\u003E\u003Cli\u003EDie Geräte müssen sicher verpackt sein.\u003C\u002Fli\u003E\u003C\u002Fp\u003E\u003Cp\u003E\u003C\u002Fp\u003EEntsprechen die Geräte bei Rückgabe nicht dem beschriebenen Zustand kann ValueNet den Ausgleich eines hierdurch bedingten Minderwertes verlangen.\u003Cp\u003E\u003C\u002Fp\u003EFür die Rückgabe der Geräte erhalten Sie nach der Bestätigung einen Link zur Erstellung des Rücksendelabels.\u003Cbr\u003EDie Geräte müssen spätestens 5 Werktage vor Ablauf des Vertrags dem Paketdienstleister übergeben werden. Bei verzögerter Rücksendung wird je angebrochenem Monat die entsprechende Umwandlungsrate fällig.\u003Cbr\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"$ctrl.selected_option == '0'\"\u003E";
pug_mixins["checkbox"].call({
attributes: {"id": "confirm_return","key": "$ctrl.return_checkbox","title": "Ich habe die Widerrufsbelehrung gelesen und akzeptiere diese.","data-cy": "vn.userDecisions.pcLeasing.buyingDecisionDialog-{{$ctrl.basket['_id']}}.checkToc"}
});
pug_html = pug_html + "\u003Cdiv class=\"row\"\u003E\u003C\u002Fdiv\u003E";
pug_mixins["checkbox"].call({
attributes: {"id": "confirm_decision","key": "$ctrl.confirmation_checkbox","title": "Ich habe obenstehenden Informationen gelesen und möchte die Endgeräte kaufen.","data-cy": "vn.userDecisions.pcLeasing.buyingDecisionDialog-{{$ctrl.basket['_id']}}.checkConfirmBuy"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"$ctrl.selected_option == '1'\"\u003E";
pug_mixins["checkbox"].call({
attributes: {"id": "confirm_decision","key": "$ctrl.confirmation_checkbox","title": "Ich habe obenstehenden Informationen gelesen und möchte die Endgeräte zurückgeben.","data-cy": "vn.userDecisions.pcLeasing.buyingDecisionDialog-{{$ctrl.basket['_id']}}.checkConfirmReturn"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cbr\u003E\u003Cdiv class=\"column small-6\"\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"$ctrl.close()\" data-cy=\"vn.userDecisions.pcLeasing.buyingDecisionDialog-{{$ctrl.basket['_id']}}.buttonCancel\"\u003E{{$ctrl.display_data.buttons.decline}}\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column small-6\"\u003E\u003Cbutton class=\"button button-primary right\" ng-click=\"$ctrl.confirm()\" ng-disabled=\"!($ctrl.confirmation_checkbox &amp;&amp; ($ctrl.selected_option == '0' ? $ctrl.return_checkbox: 'true'))\" data-cy=\"vn.userDecisions.pcLeasing.buyingDecisionDialog-{{$ctrl.basket['_id']}}.buttonSubmit\"\u003E{{$ctrl.display_data.buttons.confirm}}\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"$ctrl.is_decision_confirmed\"\u003E\u003Cdiv ng-switch=\"$ctrl.selected_option\"\u003E\u003Cdiv ng-switch-when=\"0\"\u003E\u003Cp\u003EVielen Dank für die Entscheidung. Nachfolgenden können Sie Ihre Rechnung einsehen. Diese können Sie auch Über den Knopf herunterladen. Weiter erhalten Sie alle Information zum Kauf noch einmal zusammengefasst per E-Mail. Bitte denken Sie an eine rechtzeitige Überweisung des Rechnungsbetrags.\u003C\u002Fp\u003E\u003Ccontract-preview contracturl=\"$ctrl.invoice_url\" can-download=\"true\"\u003E\u003C\u002Fcontract-preview\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-switch-when=\"1\"\u003E\u003Cp\u003EWir kommen in Kürze auf Sie mit den weiteren Schritten zur Rücksendung zu.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"column small-12\"\u003E\u003Cbutton class=\"button button-primary right\" ng-click=\"$ctrl.close()\" data-cy=\"vn.userDecisions.pcLeasing.buyingDecisionDialog-{{$ctrl.basket['_id']}}.buttonClose\"\u003EDialog schließen\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }.call(this, "fieldsetCounter" in locals_for_with ?
        locals_for_with.fieldsetCounter :
        typeof fieldsetCounter !== 'undefined' ? fieldsetCounter : undefined, "globals" in locals_for_with ?
        locals_for_with.globals :
        typeof globals !== 'undefined' ? globals : undefined, "id" in locals_for_with ?
        locals_for_with.id :
        typeof id !== 'undefined' ? id : undefined));
    ;;return pug_html;};
module.exports = template;